import { Component, Inject, OnInit } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { DocumentProcessService } from '../../../../core/services/api/document-process.service';
import { ApiDocumentProcessGridModel } from '../../../../core/models/api-document-process-grid.model';
import { ApiDocumentProcessModel } from 'src/app/core/models/api-document-process.model';
import { DocumentProcessStatus, DocumentProcessStatusTranslate } from 'src/app/core/models/enums/documentProcessStatusEnum';
import { DocumentProcessToStatus, DocumentProcessToStatusTranslate} from 'src/app/core/models/enums/documentProcessToStatusEnum';
import { DateHelper } from '../../../../core/helpers/date-helper';
import { DismissReason } from 'src/app/shared/extensions/ng-active-modal/dismiss-reason';
import { UploadDocumentComponent } from '../../components/upload-document/upload-document.component';
import { IAuthService } from 'src/app/core/services/api/contracts/auth-service';
import { SystemAccountAuthModel } from 'src/app/core/models/system-account';
import { UserRoles } from 'src/app/core/models/enums/userRoles';
import { Router } from '@angular/router';
import { BasicModalOperationResult, DialogModalComponent, IBasicModalComponentInstance } from 'src/app/shared/components/dialog-modal/dialog-modal.component';
import { PagedList } from 'src/app/core/models/pagination';
import { ConstancyType } from 'src/app/core/models/enums/constancyType';
import { Options } from 'src/app/shared/components/pagination/pagination.component';
import { FilterDocumentModel } from '../../../../core/models/filter-document.model';
import { FormBuilder, FormControl, FormGroup, NgForm } from '@angular/forms';


@Component({
  selector: 'app-documents-grid',
  templateUrl: './documents-grid.component.html',
  styleUrls: ['./documents-grid.component.scss']
})


export class DocumentsGridComponent implements OnInit {
  apiDocumentGrid: ApiDocumentProcessGridModel;
  apiDocuments: PagedList<ApiDocumentProcessModel> = new PagedList<ApiDocumentProcessModel>();
  showSpinner: boolean = true;
  documentProcessToStatusTranslate = DocumentProcessToStatusTranslate;
  documentProcessStatus = DocumentProcessStatus;
  currentUser: SystemAccountAuthModel;
  options: Options = {
    page: 1,
    size: 10
  };
  constancyType = ConstancyType;
  constancyTypeKeys = [];
  properties !: string;
  filterDocument='';
  model: FilterDocumentModel= this.emptyDocumentFilter();
  isLoading = false;
  form: FormGroup;
  statusList = DocumentProcessToStatus;
  filterChanged = false;
  constancyTypeEnum: any[] = [];
  statusListEnum: any[] = [];

  constructor(
    public translate: TranslateService,
    private documentProcessService: DocumentProcessService,
    private modalService: NgbModal,
    private builder: FormBuilder,
    private router: Router,
    @Inject("IAuthService") private authService: IAuthService
  ) {
    this.constancyTypeKeys = this.enumValues(this.constancyType);
    this.form = builder.group({
      sintraId: new FormControl(null),
      constancyType: new FormControl(null),
      startDate: new FormControl(null),
      endDate: new FormControl(null),
      organization: new FormControl(null),
      status: new FormControl(null),
    });
   }

  async ngOnInit() {
    this.currentUser = await this.authService.getCurrentProfile();
    await this.loadEnums();
    await this.loadData(this.options.page, this.options.size);
    this.showSpinner = false;
  }

  loadData = async (page?: number, itemsPerPage?: number) => {
    if (localStorage.getItem("backPageNumber") !== null) {
      var num = localStorage.getItem("backPageNumber");
      this.options = JSON.parse(num);
     }
    
    var pagedList = await this.documentProcessService.getDocuments(this.options.page, this.options.size);
    this.apiDocuments = pagedList;
    localStorage.removeItem("backPageNumber");
    this.isAnyDocumentSignatureInProgress();
  }

  async addNewDocument() {
    const modalRef = this.modalService.open(UploadDocumentComponent, {
      backdrop: "static",
      keyboard: false,
      centered: true,
      size: "lg",
    });

    var result = await modalRef.result;
    if (result == DismissReason.Saved) {
      this.showSpinner = true;
      await this.loadData(this.options.page, this.options.size);
      this.showSpinner = false;
    }

    if (result == DismissReason.Cancelled) {
      this.showSpinner = true;
      await this.loadData(this.options.page, this.options.size);
      this.showSpinner = false;
    }
  }

  convertDate(dateToBeConverted: Date) {
    return DateHelper.convertDate(dateToBeConverted)
  }

  seeDetailsClick(documentProcess: ApiDocumentProcessModel) {
    
    localStorage.setItem("backPageNumber", JSON.stringify(this.options));
    if (this.currentUser && this.currentUser.currentRole == UserRoles.Admin) {
      this.router.navigate([
        "/admin/documents/details/",
        documentProcess.documentProcessId,
      ]);
    }

    if (this.currentUser && this.currentUser.currentRole == UserRoles.Operador) {
      this.router.navigate([
        "/guest/documents/details/",
        documentProcess.documentProcessId,
      ]);
    }
  }

  async downloadQR(documentProcess: ApiDocumentProcessModel) {
    try {
      this.showSpinner = true;      
      await this.documentProcessService.generateQRCodeFileAsync(documentProcess.documentProcessId);
      this.showSpinner = false;      
    } catch (error) {
      const modalInstance = this.modalService.open(DialogModalComponent)
        .componentInstance as IBasicModalComponentInstance;
      modalInstance.title = "Error";
      modalInstance.body = this.translate.instant("documentsGrid.downloadQRFileError");
      modalInstance.type = BasicModalOperationResult.Error;
      this.showSpinner = false;
    }

  }
 // todo: pasar a helper
  enumKeys(target: Record<string, number | string>): string[] {
    const allKeys: string[] = Object.keys(target);
    const parsedKeys: string[] = [];

    for (const key of allKeys) {
      const needToIgnore: boolean
        = target[target[key]]?.toString() === key && !isNaN(parseInt(key));

      if (!needToIgnore) {
        parsedKeys.push(key);
      }
    }

    return parsedKeys;
  }

  enumValues(target: Record<string, number | string>): Array<string | number> {
    const keys: string[] = this.enumKeys(target);
    const values: Array<string | number> = [];

    for (const key of keys) {
      values.push(target[key]);
    }

    return values;
  }
  async isAnyDocumentSignatureInProgress(){
    let documentProcessesInProgress = this.apiDocuments.items.filter(x => x.documentSignatureInProgress)
    for (const documentProcessInProgress of documentProcessesInProgress)
    {
      await this.isDocumentSignatureInProgress(documentProcessInProgress.documentProcessId);
    }
  }

  async isDocumentSignatureInProgress(
    documentProcessId: number,
    maxRetries: number = 20,
    msRefreshTime: number = 2000,
    retry: number = 0
  ) {
    if (retry < maxRetries) {
      setTimeout(async () => {
        let currentDocumentProcessIndex = this.apiDocuments.items.findIndex(
          (obj) => obj.documentProcessId == documentProcessId
        );
        let currentDocumentProcess = this.apiDocuments.items.filter(
          (x) => x.documentProcessId == documentProcessId
        )[0];
        currentDocumentProcess = await this.documentProcessService.getDocumentProcessDetails(documentProcessId);
        this.apiDocuments.items[currentDocumentProcessIndex] = currentDocumentProcess;

        if (currentDocumentProcess.documentSignatureInProgress) {
          setTimeout(() => {
            this.isDocumentSignatureInProgress(
              documentProcessId,
              maxRetries,
              msRefreshTime,
              retry++
            );
          }, msRefreshTime);
        }
      }, msRefreshTime);
    }
  }

  flagPending(apiDocument: ApiDocumentProcessModel ){
    if(apiDocument.documentSignatureInProgress)
      return " ...";
    else
      return '';
  }

  public emptyDocumentFilter():FilterDocumentModel 
  {
    return {
      sintraId: "",
      organization: "",
      constancyType:null,
      status: null,
      startDate: null,
      endDate: null
    };
  }

  public async onSubmit(){
    this.model.constancyType=null;
    this.model.sintraId='';
    this.model.organization='';
    this.model.status=null;
    this.model.startDate=null;
    this.model.endDate=null;
  
}

async loadEnums(){
  for(let i in ConstancyType){
    if(isNaN(Number(i)))
    {
      this.constancyTypeEnum.push({text:i, value:ConstancyType[i]})
    }
  }
  for(let i in DocumentProcessToStatus){
    if(isNaN(Number(i)))
    {
      this.statusListEnum.push({text:i, value:DocumentProcessToStatus[i]})
    }
  }


}
}


